import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import { EffectsContainer } from '../../../../../mixins/withEffects';
import CommunityNavigationWidgetGroupModel from '../group';
import CommunityNavigationWidgetItemModel from '../item';
import { CommunityNavigationWidgetLinkConfig } from '../link';
import './group.html';

@injectable()
export default class CommunityDesktopNavigationWidgetGroupVM {
    header: CommunityNavigationWidgetLinkConfig

    title: Subscribable<string>
    css: Subscribable<string>

    items: Subscribable<Array<CommunityNavigationWidgetItemModel>>

    constructor(
        @inject(wccModules.componentConfig) model: CommunityNavigationWidgetGroupModel,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) protected effects: EffectsContainer
    ) {
        this.title = model.title;
        this.css = model.css;
        this.items = model.items;

        this.header = {
            title: model.title,
            toDoCount: model.toDoCount,
            isRoot: model.isRoot()
        }

        effects.register(() => {

            setTimeout(() => {
                // create a resize observer on our dropdown list sub menu
                const resizeObserver = new ResizeObserver((entries) => {
                    //console.log(entries);
                    for (let i = 0; i < entries.length; i++) {                        
                        let el = entries[i].target;
                        let elWidth = entries[i].contentRect.width;
                            
                        let boundingClientRect = el.getBoundingClientRect();

                        if (boundingClientRect.left + elWidth > window.innerWidth) {
                            // move our element to the left of the main dropdown by the width of the element
                            el.setAttribute('style', 'position:absolute');
                            el.setAttribute('style', `left:${-elWidth}px`);
                            el.classList.remove('fix-overlap');
                            // Note that removing the observer will mean resizing/change to the window will break the dropdown again                            
                            //resizeObserver.unobserve(el);
                        }
                        else { // remove observer on elements that don't break the window size
                            //resizeObserver.unobserve(el);
                        }
                    }
                        
                });

                let htmlCollection = document.getElementsByClassName('dropdown-menu fix-overlap');

                Array.prototype.forEach.call(
                    htmlCollection,
                    (element:Element) => resizeObserver.observe(element)
                );                
            }, 2000); // deal with things not being ready. We can make this better by building a readiness into the component
        });

        ko.applyBindingsToNode(info.element, {
            'css': {
                'community__desktop-navigation__group': true
            }
        });

        ko.applyBindingsToNode(info.element, {
            'css': this.css
        });
    }
}